class CollectionHeader {
  constructor(section) {
    this.section = section;
    this.swiperContainer = this.section.querySelector('.collection-header-swiper');
    this.filters = this.section.querySelectorAll('.section-collection-header__filter');
    this.scrollProgress = this.section.querySelector('.section-collection-header__scroll-progress-bar');
    this.swiper = null;

    this.init();
  }

  init() {
    this.initSwiper();
    this.initFilters();
  }

  initSwiper() {
    if (!this.swiperContainer) return;

    // Only initialize Swiper on mobile
    const initSwiperOnMobile = () => {
      if (window.innerWidth <= 989) {
        if (!this.swiper) {
          this.swiper = new Swiper(this.swiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: {
              enabled: true,
              sticky: false,
            },
            watchSlidesProgress: true,
            resistanceRatio: 0,
            slideToClickedSlide: false,
            preventClicks: false,
            preventClicksPropagation: false,
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
            on: {
              init: (swiper) => {
                this.updateScrollProgress(swiper);
              },
              progress: (swiper) => {
                this.updateScrollProgress(swiper);
              },
              slideChange: (swiper) => {
                this.updateScrollProgress(swiper);
              },
              setTranslate: (swiper) => {
                this.updateScrollProgress(swiper);
              },
            },
          });
        }
      } else {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }
    };

    initSwiperOnMobile();
    window.addEventListener('resize', initSwiperOnMobile);
  }

  updateScrollProgress(swiper) {
    if (!this.scrollProgress || !swiper) return;

    // Calculate the scroll progress based on translate position
    const maxTranslate = swiper.maxTranslate();
    const minTranslate = swiper.minTranslate();
    const currentTranslate = swiper.translate;

    // Calculate progress (0 to 1)
    let progress = 0;
    if (maxTranslate !== minTranslate) {
      progress = Math.abs((currentTranslate - minTranslate) / (maxTranslate - minTranslate));
    }

    // Clamp between 0 and 1
    progress = Math.max(0, Math.min(1, progress));

    // Calculate the thumb width based on visible ratio
    const containerWidth = swiper.width;
    const slidesWidth = swiper.virtualSize;
    const visibleRatio = containerWidth / slidesWidth;

    // Thumb width as percentage of container
    const thumbWidth = visibleRatio * 100;

    // Calculate left position (scrollable area)
    const scrollableWidth = 100 - thumbWidth;
    const thumbLeft = progress * scrollableWidth;

    this.scrollProgress.style.width = `${thumbWidth}%`;
    this.scrollProgress.style.left = `${thumbLeft}%`;
  }

  initFilters() {
    this.filters.forEach((filter) => {
      filter.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleFilterClick(filter, e);
      });
    });
  }

  handleFilterClick(clickedFilter) {
    const filterTag = clickedFilter.dataset.filterTag;
    const isDefault = clickedFilter.dataset.isDefault === 'true';

    // Update active state
    this.filters.forEach((filter) => {
      filter.classList.remove('section-collection-header__filter--active');
    });
    clickedFilter.classList.add('section-collection-header__filter--active');

    // Dispatch custom event for filtering products
    const filterEvent = new CustomEvent('collectionFilter', {
      detail: {
        tag: filterTag,
        isDefault: isDefault,
      },
      bubbles: true,
    });
    document.dispatchEvent(filterEvent);

    // Update product count for the active filter
    this.updateProductCount(clickedFilter, filterTag, isDefault);
  }

  updateProductCount(filter, filterTag, isDefault) {
    const countElement = filter.querySelector('.filter-count');
    if (!countElement) return;

    // Get all products from the page
    const products = document.querySelectorAll('[data-filter-tags]');
    let count = 0;

    if (isDefault) {
      count = products.length;
    } else {
      products.forEach((product) => {
        const filterTags = product.dataset.filterTags;
        if (filterTags && filterTags.includes(filterTag)) {
          count++;
        }
      });
    }

    countElement.textContent = count;
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionHeader);
} else {
  initCollectionHeader();
}

function initCollectionHeader() {
  const sections = document.querySelectorAll('[data-section-type="w-collection-header"]');
  sections.forEach((section) => {
    new CollectionHeader(section);
  });
}

// Shopify section events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-collection-header"]');
    if (section) {
      new CollectionHeader(section);
    }
  });
}
